import styled from 'styled-components';
import {
  screenSize,
  inputBorderColor,
  whiteColor,
  mediumFont,
  regularFont,
  boldFont,
  primaryColor,
} from '@app/styles';
import ProfileDefaultImageUrl from '@app/assets/images/user_profile.svg';
import Logo from '@app/assets/images/munitechlogo.png';

type Props = {
  image?: string;
  active?: boolean;
  disabled?: boolean;
};

type UserProps = {
  active?: boolean;
};

type UserImageProps = {
  image?: string;
};

export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 60px);
  width: 100%;
  margin-top: 60px;
  overflow-x: hidden;
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  @media (${screenSize.maxMobile}) {
    background: ${whiteColor};
  }
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
`;
export const SideNav = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: #ffffff;
  @media (${screenSize.tablet}) {
    width: 320px;
    border-left: none;
    border-right: 1px solid ${inputBorderColor};
  }
`;
export const DesktopSideNav = styled.div`
  display: block;
`;

export const ListView = styled.div`
  @media (${screenSize.maxMobile}) {
    display: none;
  }
  @media (${screenSize.tablet}) {
    dispaly: flex;
    width: calc(100vw - 320px);
    height: 100%;
    flex-direction: column;
    background-color: ${whiteColor};
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

export const SideNavContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #cecece;
  // @media (${screenSize.tablet}) {
    padding: 10px 15px 10px 20px;
  // }
`;
export const AddUserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 5px;
  @media (${screenSize.tablet}) {
  }
`;
export const TotalUsersText = styled.div`
  font-style: normal;
  font-size: 15px;
  line-height: 19px;
  color: #172b4d;
  ${mediumFont};
`;
export const ButtonBox = styled.div`
  // width: 110px;
  button {
    height: 32px;
  }
`;
export const SearchBox = styled.div`
  input {
    background: #eff1f2;
    border: 1px solid #dce3eb;
  }
`;

export const UsersContainer = styled.div`
  height: calc(100% - 100px);
  overflow-x: hidden;
  overflow-y: hidden;
  @media (${screenSize.tablet}) {
    overflow-y: auto;
  }
`;
export const UserScrollContainer = styled.div`
  @media (${screenSize.tablet}) {
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 30px;
  }
`;
export const UsersBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #e6e6e6;
  &:hover {
    background: #eff1f2;
  }
  cursor: pointer;
   ${({ active }: UserProps) => {
     if (active) {
       return `background: #eff1f2;
             `;
     }
   }}
  // @media (${screenSize.tablet}) {
    min-height: 77px;
    padding: 15px 15px 10px 20px;
  // }
`;

export const UserImage = styled.div`
  // display: none;
  // @media (${screenSize.tablet}) {
    display: block;
    width: 38px;
    height: 38px;
    margin-right: 10px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    background-image: url(${ProfileDefaultImageUrl});
    ${({ image }: Props) => {
      if (image) {
        return `background-image:url(${image});
             `;
      }
    }}
  // }
`;

export const UserDetailsCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (${screenSize.tablet}) {
  }
`;
export const UserName = styled.div`
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  color: #49515f;
  ${mediumFont};
  padding-bottom: 5px;
`;

export const UserType = styled.div`
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  color: #88909b;
  ${regularFont};
  padding-bottom: 5px;
`;
export const UserEmail = styled.div`
  font-style: normal;
  font-size: 13px;
  line-height: 17px;
  color: #445570;
  mix-blend-mode: normal;
  opacity: 0.5;
  ${regularFont};
`;

export const ListContainer = styled.div`
  width: 90%;
  @media (${screenSize.tablet}) {
    width: 85%;
    margin-left: 70px;
  }
`;
export const NameBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  // @media (${screenSize.tablet}) {
    margin-top: 20px;
  // }
  @media (${screenSize.maxMobile}){
    padding:16px;
  }
`;
export const NameCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  @media (${screenSize.tablet}) {
  }
`;

export const Image = styled.div`
  // display: none;
  // @media (${screenSize.tablet}) {
    display: block;
    width: 48px;
    height: 48px;
    margin-right: 10px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    background-image: url(${ProfileDefaultImageUrl});
    ${({ image }: UserImageProps) => {
      if (image) {
        return `background-image:url(${image});
             `;
      }
    }}
  // }
`;
export const MobileDropdown = styled.div`
  position: absolute;
  z-index: 2;
  bottom: 40px;
  right: 15px;
`;
export const MobileDropdownOption = styled.div`
  font-size: 18px;
  display: block;
  color: #100f1f;
  opacity: 1;
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 6px;
  line-height: 26px;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
        button{
          background-color:#ccc;
          pointer-events:none;
        }
    `;
    }
  }}
`;
export const MobileOptions = styled.div`
  position: fixed;
  background: #ffffff;
  z-index: 3;
  height: auto;
  top: 130px;
  right: 15px;
  border: 1px solid #dce0e8;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 11px 20px 0 rgb(47 54 65 / 50%);
  @media (${screenSize.tablet}) {
    right: 30px;
    top: 110px;
  }
  @media (${screenSize.desktop}) {
    display: none;
  }
`;
export const MobileHeader = styled.div`
  display: block;
  cursor: pointer;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const Name = styled.div`
  font-family: Noto Serif;
  font-style: normal;
  font-size: 18px;
  line-height: 21px;
  color: #000000;
  margin-right: 15px;
  ${mediumFont};
`;

export const Heading = styled.div`
  font-family: Noto Serif;
  font-style: normal;
  font-size: 18px;
  line-height: 21px;
  color: #000000;
  margin-top: 10px;
  ${mediumFont};
`;

export const DetailsCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 5px;
  @media (${screenSize.tablet}) {
    margin-top: 36px;
  }
  @media (${screenSize.maxMobile}) {
    margin-top: 20px;
    padding: 0px 16px;
  }
`;
export const ContactText = styled.div`
  font-style: normal;
  font-size: 16px;
  line-height: 21px;
  color: #3240a1;
  ${mediumFont};
`;

export const FullLine = styled.div`
  height: 2px;
  width: 100%;
  background: #cecece;
  position: relative;
`;
export const ColoredLine = styled.div`
  position: absolute;
  width: 114px;
  height: 2px;
  background: #3240a1;
`;
export const ParentLine = styled.div`
  display: flex;
  @media (${screenSize.tablet}) {
  }
`;

export const UserDetailsBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  // @media (${screenSize.tablet}) {
    margin-top: 26px;
  // }
  @media (${screenSize.maxMobile}){
    padding:0px 16px;
    background:${whiteColor}
  }
`;
export const Label = styled.div`
  font-size: 14px;
  line-height: 21px;
  color: #6b6f8c;
  // padding-bottom: 5px;
  ${regularFont};
`;
export const Value = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #040506;
  ${regularFont};
`;

export const Infocard = styled.div`
  position: relative;
  label {
    padding-left: 0px;
  }
  @media (${screenSize.tablet}) {
    width: 300px;
    margin-top: 0;
    margin-right: 30px;
  }
`;
export const CompanyData = styled.div`
  position: relative;
  label {
    padding-left: 0px;
  }
  margin-top: 24px;
  @media (${screenSize.tablet}) {
    width: 300px;
    margin-top: 0;
    margin-right: 30px;
  }
`;
export const UserEmailComp = styled.div`
  position: relative;
  label {
    padding-left: 0px;
  }
  @media (${screenSize.tablet}) {
    width: 300px;
    margin-top: 0;
    margin-right: 30px;
  }
  @media (${screenSize.maxMobile}) {
    margin-top: 24px;
  }
`;
export const InfocardPrimary = styled.div`
  position: relative;
  height: 100px;
  @media (${screenSize.tablet}) {
    width: 300px;
    margin-top: 0;
    margin-right: 30px;
  }
`;

export const DetailsBox = styled.div`
  display: flex;
  margin-top: 24px;
  @media (${screenSize.maxMobile}) {
    flex-direction: column;
  }
`;

export const SelectComp = styled.div`
  display: flex;
`;
export const FormBox = styled.div`
  display: flex;
  @media (${screenSize.maxMobile}) {
    flex-direction: column;
  }
  @media (${screenSize.tablet}) {
    margin-top: 4px;
  }
`;

export const PermissionsBox = styled.div`
  display: flex;
  flex-direction: column;
  @media (${screenSize.tablet}) {
    margin-top: 44px;
  }
`;
export const PermissionsFormBox = styled.div`
  display: flex;
  flex-direction: column;
  @media (${screenSize.tablet}) {
    margin-top: 30px;
  }
`;
export const PermissionsHeading = styled.div`
  padding-bottom: 15px;
`;
export const AccessText = styled.div`
  font-size: 12px;
  line-height: 14px;
  color: #999999;
  padding-bottom: 5px;
  text-transform: uppercase;
  ${regularFont};
`;

export const PermissionsCard = styled.div`
  width: 607px;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  @media (${screenSize.tablet}) {
    padding: 0px 10px 0px;
  }
`;

export const PermissionText = styled.div`
  font-size: 14px;
  line-height: 16px;
  color: #5d6c84;
  ${regularFont};
`;
export const ButtonGroup = styled.div`
  display: flex;
`;
export const Status = styled.div`
  display: flex;
  > div {
    font-size: 13px;
  }
`;
export const SwitchCard = styled.div`
  margin-right: 10px;
`;

export const ButtonCard = styled.div`
  min-width: 54px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6f8;
  color: #42526e;
  font-size: 14px;
  border:2px solid #FFFFFF;
  ${({ active }: Props) => {
    if (active) {
      return `background: #DEEBFF;
              color: #0052CC;
             `;
    }
  }}
  @media (${screenSize.tablet}) {
  }
`;

export const PrimaryButton = styled.div`
  min-width: 60px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6f8;
  color: #42526e;
  font-size: 14px;
  border:2px solid #FFFFFF;
  ${({ active }: Props) => {
    if (active) {
      return `background: #DEEBFF;
              color: #0052CC;
             `;
    }
  }}
  @media (${screenSize.tablet}) {
  }
`;
export const MunitechLogo = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  margin-left: 10px;
  border-radius: 8px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${Logo});
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 320px);
  }
`;

export const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const FormButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 16px;
  @media (${screenSize.tablet}) {
  }
`;

export const DialogButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 20px 0px;
  @media (${screenSize.tablet}) {
  }
`;
export const DetailButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (${screenSize.tablet}) {
  }
`;

export const CancelButton = styled.div`
${({ disabled }: Props) => {
  if (disabled) {
    return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
  }
}}
  @media (${screenSize.tablet}) {
    margin: 0px 15px;
    width: 100px;
    height: 36px;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #eff0f2;
      border-radius: 4px;
      &:hover {
        background: #ccc;
        color: white;
      }
    }
  }
`;
export const SaveButton = styled.div`
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
  @media (${screenSize.tablet}) {
    width: 114px;
    margin-right:0px;
  }
`;
export const DeleteButton = styled.div`
  margin-left: 15px;
  @media (${screenSize.tablet}) {
    width: 114px;
    margin-right: 0px;
  }
`;
export const ContactBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (${screenSize.tablet}) {
  }
`;
export const ErrorMessage = styled.p`
  font-size: 14px;
  color: #ec4160;
  margin: 0;
  position: absolute;
  // bottom: -22px;
  // @media (${screenSize.tablet}) {
    bottom: 0;
  // }
`;
export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 15px;
  margin: 10px 15px 0px;
  // @media (${screenSize.tablet}) {
    background: #f4f5f6;
    height: 30px;
    margin-bottom: 40px;
    flex-direction: row;
    &:hover {
      background-color: rgb(243 247 253);
    }
  // }
`;

export const SeeMoreContainer = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const SeeMoreText = styled.div`
  fontsize: 18px;
  ${boldFont};
  color: #17335a;
  text-align: center;
`;
export const SelectErrorMessage = styled.p`
  font-size: 14px;
  color: #ec4160;
  margin-top: 5px;
  @media (${screenSize.tablet}) {
    bottom: 0;
  }
`;
export const SavingIndicator = styled.div`
  right: 30px;
  top: 15px;
  svg {
    path {
      fill: ${primaryColor};
    }
  }
  @media (${screenSize.tablet}) {
    left: 30px;
    right: auto;
    top: 35px;
    svg {
      path {
        fill: ${primaryColor};
      }
    }
  }
`;

export const SeeMoreIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 15px;
  min-height: 100px;
  background-color: red;
  svg {
    path {
      fill: ${primaryColor};
    }
  }
  @media (${screenSize.tablet}) {
    svg {
      path {
        fill: ${primaryColor};
      }
    }
  }
`;
export const NoDataText = styled.div`
  font-size: 20px;
  ${boldFont};
  color: black;
  opacity: 0.5;
`;

export const NoDataCard = styled.div`
  height: 70%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (${screenSize.tablet}) {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
